<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_5044_158"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <path
        d="M19.4622 0H4.72384C2.11493 0 0 2.09867 0 4.6875V19.3125C0 21.9013 2.11493 24 4.72384 24H19.4622C22.0711 24 24.186 21.9013 24.186 19.3125V4.6875C24.186 2.09867 22.0711 0 19.4622 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_5044_158)">
      <g opacity="0.7">
        <mask
          id="mask1_5044_158"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="1"
          y="-1"
          width="21"
          height="14"
        >
          <g opacity="0.7">
            <path
              d="M21.7297 12.5479H1.32275V-0.863068H21.7297V12.5479Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask1_5044_158)">
          <path
            d="M12.1937 20.7117C17.039 20.7117 20.9668 16.8141 20.9668 12.0061C20.9668 7.19811 17.039 3.30048 12.1937 3.30048C7.3485 3.30048 3.42065 7.19811 3.42065 12.0061C3.42065 16.8141 7.3485 20.7117 12.1937 20.7117Z"
            fill="url(#paint0_radial_5044_158)"
          />
        </g>
      </g>
      <path
        opacity="0.3"
        d="M21.1692 12.5625V13.6875H3.02966V12.5625H21.1692Z"
        fill="#1373D9"
      />
      <path
        d="M12.2835 3.28363C16.1326 3.38297 19.1853 6.59066 19.1853 10.4855V16.7629C19.1853 18.9255 17.4606 20.7188 15.2841 20.7188C13.1548 20.7188 11.2493 18.9722 11.2493 16.7629V11.0797H9.3099L9.28222 11.0786C9.00823 11.0579 8.87262 10.7329 9.05156 10.526L9.07057 10.5057L11.7403 7.85651C11.9264 7.67194 12.2209 7.6605 12.4204 7.82209L12.4588 7.85651L15.1285 10.5057C15.3419 10.7174 15.191 11.0796 14.8892 11.0797H12.9498V16.7629C12.9499 17.9911 14.0436 19.0312 15.2841 19.0312C16.4775 19.0312 17.4847 18.0378 17.4847 16.7629V10.4855C17.4847 7.46456 15.1272 5.04546 12.2376 4.97059L12.0996 4.96875C9.14738 4.96875 6.71439 7.4166 6.71438 10.4855V12.5625H5.01379V10.4855C5.01381 6.52881 8.16425 3.28125 12.0996 3.28125L12.2835 3.28363Z"
        fill="url(#paint1_linear_5044_158)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_5044_158"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.1937 19.2923) rotate(-90) scale(15.9918 9.16878)"
      >
        <stop stop-color="#0B4186" stop-opacity="0.45" />
        <stop offset="1" stop-color="#0B4186" stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_5044_158"
        x1="1.85532"
        y1="1.89324"
        x2="11.8987"
        y2="23.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6AA9E5" />
        <stop offset="0.994972" stop-color="#0D5BB2" />
      </linearGradient>
    </defs>
  </svg>
</template>
